import clsx from 'clsx';
import Enllac from 'components/3catinfo/Enllac';
import Imatge from 'components/3catinfo/Imatge';
import styles from './destacatRankingHoritzontal.module.scss';

const DestacatRankingHoritzontal = (props) => {
    const { item, numberRanking, positionImg, estil, routePath, testId, marcatgeAudienciesClick } = props;
    const { id, titol, permatitle, imatges, tipologia } = item;
    const route = { slug: permatitle || titol, id: id, tipologia: tipologia, type: routePath };
    const stylesDestacat = clsx({
        [styles.destacat]: true,
        [styles.right]: positionImg === 'right',
        [styles[estil]]: true
    });

    const stylesWrapper = clsx({
        [styles.wrapper]: true,
        [styles.wrapperRanking]: true
    });

    return item ? (
        <div className={stylesDestacat} {...(testId && { 'data-testid': testId })}>
            <div className={styles.number} data-testid='destacat-num-ranking'>
                {numberRanking}
            </div>
            <div className={stylesWrapper}>
                <div className={styles.imatgeWrapper} data-testid='destacat-content-imatge'>
                    <Imatge
                        className={styles.imatge}
                        imatges={imatges}
                        tipus='web_destacat'
                        layout='fill'
                        objectFit='cover'
                        data_testid='destacat-img'
                    />
                </div>
            </div>
            <div className={styles.title} data-testid='destacat-titol'>
                <Enllac route={route} dataTestId='destacat-enllac' marcatgeAudienciesClick={marcatgeAudienciesClick}>
                    <span dangerouslySetInnerHTML={{ __html: titol }}></span>
                </Enllac>
            </div>
        </div>
    ) : (
        <></>
    );
};

export default DestacatRankingHoritzontal;
